import { CamposGenericos } from "./camposGenericos";

export class Estado extends CamposGenericos {
    colorGrupoEstado: string;
    comprobante: string;
    descripcion: string;
    grupoEstado: string;
    id: string;
    idComprobante: string;
    idGrupoEstado: string;
    idPais: string;
}